import { UserResponse, TestVariant } from '../types';

const RESPONSES_KEY = 'user_test_responses';
const USER_ID_KEY = 'user_test_id';
const SEEN_VARIANTS_KEY = 'user_seen_variants';

// Generate a unique user ID if one doesn't exist
export const getUserId = (): string => {
  let userId = localStorage.getItem(USER_ID_KEY);
  
  if (!userId) {
    userId = `user_${Date.now()}_${Math.random().toString(36).substring(2, 9)}`;
    localStorage.setItem(USER_ID_KEY, userId);
  }
  
  return userId;
};

// Save which variants a user has seen
export const saveSeenVariant = (variantId: string): void => {
  const seenVariants = getSeenVariants();
  if (!seenVariants.includes(variantId)) {
    seenVariants.push(variantId);
    localStorage.setItem(SEEN_VARIANTS_KEY, JSON.stringify(seenVariants));
  }
};

// Get the variants a user has already seen
export const getSeenVariants = (): string[] => {
  const seenVariants = localStorage.getItem(SEEN_VARIANTS_KEY);
  return seenVariants ? JSON.parse(seenVariants) : [];
};

// Save user test response
export const saveResponse = (response: UserResponse): void => {
  const responses = getResponses();
  responses.push(response);
  localStorage.setItem(RESPONSES_KEY, JSON.stringify(responses));
};

// Get all stored responses
export const getResponses = (): UserResponse[] => {
  const responses = localStorage.getItem(RESPONSES_KEY);
  return responses ? JSON.parse(responses) : [];
};

// Clear all stored data
export const clearAllData = (): void => {
  localStorage.removeItem(RESPONSES_KEY);
  localStorage.removeItem(USER_ID_KEY);
  localStorage.removeItem(SEEN_VARIANTS_KEY);
};

// Assign a variant to a user, ensuring they get a random variant
export const assignVariant = (variants: TestVariant[]): TestVariant | null => {
  if (variants.length === 0) {
    return null;
  }
  
  // Randomly select from all variants
  const randomIndex = Math.floor(Math.random() * variants.length);
  return variants[randomIndex];
};